import React, { memo } from 'react';
import { Box, Text, VStack, HStack, Badge } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';

export const Device = memo(({ device }) => {
    const { t } = useTranslation();

    return (
        <Box w='150px' minW='350px' borderWidth='1px' borderRadius='lg' overflow='hidden'>
            <Box m='5px'>
                <Text fontSize='xl'>{device.modelName}</Text>
                <Box display='flex' alignItems='center' pl='20px' pt='10px' pb='0px'>
                    <VStack spacing={1} align="stretch">
                        {[0, 1, 2, 3].map((index) => (
                            <HStack key={index} spacing={4}>
                                <Box
                                    w="16px"
                                    h="16px"
                                    borderRadius="full"
                                    bg={device.status[index] === '0' ? 'green.200' : 'red.500'}
                                    boxShadow={`0 0 8px ${device.status[index] === '0' ? 'green.200' : 'red.500'}`}
                                    flexShrink={0}
                                />
                                <Text fontSize='l' flex={1}>升降機 {device[`elevator${index + 1}`]}</Text>
                                <Badge
                                    colorScheme={device.status[index] === '0' ? "green" : "red"}
                                    textTransform="capitalize"
                                >
                                    {device.status[index] === '1' ? '故障' : '正常'}
                                </Badge>
                            </HStack>
                        ))}

                        {[4, 5].map((index) => (
                            <HStack key={index} spacing={4}>
                                <Box
                                    w="16px"
                                    h="16px"
                                    borderRadius="full"
                                    bg={device.status[index] === '0' ? 'green.200' : 'red.500'}
                                    boxShadow={`0 0 8px ${device.status[index] === '0' ? 'green.200' : 'red.500'}`}
                                    flexShrink={0}
                                />
                                <Text fontSize='l' flex={1}>消防警報 {device[`fire${index - 3}`]}</Text>
                                <Badge
                                    colorScheme={device.status[index] === '0' ? "green" : "red"}
                                    textTransform="capitalize"
                                >
                                    {device.status[index] === '1' ? '警報' : '正常'}
                                </Badge>
                            </HStack>
                        ))}

                        <HStack spacing={4}>
                            <Box
                                w="16px"
                                h="16px"
                                borderRadius="full"
                                bg={device.alive === 0 ? 'green.200' : 'red.500'}
                                boxShadow={`0 0 8px ${device.alive === 0 ? 'green.200' : 'red.500'}`}
                                flexShrink={0}
                            />
                            <Text fontSize='l' flex={1}>住戶警報 {device.deviceName}</Text>
                            <Badge
                                colorScheme={device.alive === 0 ? "green" : "red"}
                                textTransform="capitalize"
                            >
                                {device.alive === 1 ? '警報' : '正常'}
                            </Badge>
                        </HStack>
                    </VStack>
                </Box>
            </Box>
        </Box>
    )
});